import { render, staticRenderFns } from "./DeliveryList.vue?vue&type=template&id=76da17f9&scoped=true&"
import script from "./DeliveryList.vue?vue&type=script&lang=ts&"
export * from "./DeliveryList.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryList.vue?vue&type=style&index=0&id=76da17f9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76da17f9",
  null
  
)

export default component.exports